/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 9L15 6M18 9L15 12M18 9H13.4C11.1598 9 10.0397 9 9.18404 9.43597C8.43139 9.81947 7.81947 10.4314 7.43597 11.184C7 12.0397 7 13.1598 7 15.4V17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				width="20"
				height="20"
				rx="5"
				transform="matrix(1 0 0 -1 2 22)"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 9L15 6M18 9L15 12M18 9H14.5C12.1703 9 11.0054 9 10.0866 9.3806C8.86144 9.88807 7.88807 10.8614 7.3806 12.0866C7 13.0054 7 14.1703 7 16.5V16.5V17.0001M10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967C14.1768 5.76256 14.1768 6.23744 14.4697 6.53033L16.1893 8.25H13.4H13.367H13.367C12.2749 8.25 11.4094 8.24999 10.7117 8.30699C9.99834 8.36527 9.39472 8.48688 8.84354 8.76772C7.94978 9.22312 7.22312 9.94978 6.76772 10.8435C6.48688 11.3947 6.36527 11.9983 6.30699 12.7117C6.24999 13.4094 6.24999 14.2748 6.25 15.367V15.367V15.4V17.0001C6.25 17.4143 6.58579 17.7501 7 17.7501C7.41421 17.7501 7.75 17.4143 7.75 17.0001V15.4C7.75 14.2675 7.75058 13.4633 7.80201 12.8339C7.85271 12.2133 7.94909 11.829 8.10423 11.5245C8.41582 10.913 8.913 10.4158 9.52453 10.1042C9.829 9.94909 10.2133 9.85271 10.8339 9.80201C11.4633 9.75058 12.2675 9.75 13.4 9.75H16.1893L14.4697 11.4697C14.1768 11.7626 14.1768 12.2374 14.4697 12.5303C14.7626 12.8232 15.2374 12.8232 15.5303 12.5303L18.5303 9.53033C18.8232 9.23744 18.8232 8.76256 18.5303 8.46967L15.5303 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M18 9L15 6M18 9L15 12M18 9H14.5C12.1703 9 11.0054 9 10.0866 9.3806C8.86144 9.88807 7.88807 10.8614 7.3806 12.0866C7 13.0054 7 14.1703 7 16.5V16.5V17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 9L15 6M18 9L15 12M18 9H14.5C12.1703 9 11.0054 9 10.0866 9.3806C8.86144 9.88807 7.88807 10.8614 7.3806 12.0866C7 13.0054 7 14.1703 7 16.5V16.5V17.0001M10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.4697 5.46959C14.7626 5.1767 15.2374 5.1767 15.5303 5.46959L18.5303 8.46959C18.8232 8.76248 18.8232 9.23736 18.5303 9.53025L15.5303 12.5303C15.2374 12.8231 14.7626 12.8231 14.4697 12.5303C14.1768 12.2374 14.1768 11.7625 14.4697 11.4696L16.1893 9.74992H13.4C12.2675 9.74992 11.4633 9.7505 10.8339 9.80193C10.2133 9.85263 9.829 9.94901 9.52453 10.1041C8.913 10.4157 8.41582 10.9129 8.10423 11.5245C7.94909 11.8289 7.85271 12.2132 7.80201 12.8338C7.75058 13.4632 7.75 14.2674 7.75 15.3999V17C7.75 17.4142 7.41421 17.75 7 17.75C6.58579 17.75 6.25 17.4142 6.25 17V15.3999L6.25 15.3669C6.24999 14.2748 6.24999 13.4093 6.30699 12.7117C6.36527 11.9983 6.48688 11.3946 6.76772 10.8435C7.22312 9.9497 7.94978 9.22304 8.84355 8.76764C9.39472 8.4868 9.99835 8.36519 10.7117 8.30691C11.4094 8.24991 12.2749 8.24992 13.367 8.24992H13.4H16.1893L14.4697 6.53025C14.1768 6.23736 14.1768 5.76248 14.4697 5.46959Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
